export default {
  settings: {
    'endpointsSectionTitle': 'Endpoints del servizio (oppure URI o URL completa)',
    'language': 'Lingua',
    'appLocale': 'Lingua applicazione',
    'unit': 'Unità',
    'areaUnit': 'Unità area',
    'saveToLocalStorage': 'Salva nel browser',
    'routeInstructions': 'Istruzioni itinerario',
    'randomizedIsochroneColors': 'Colori isocrone causali',
    'distanceMarkers': 'Indicatori distanza',
    'elevationProfile': 'Profilo altitudine',
    'mapSettings': 'Visualizzazione mappa e informazioni extra',
    'defaultMapSettingsRestored': 'Impostazioni standard ripristinate',
    'endpointsTitle': {
      'directions': 'Direzioni',
      'isochrones': 'Isocrone',
      'geocodeSearch': 'Geocodifica',
      'autocomplete': 'Autocompletamento geocodifica',
      'pois': 'POIs',
      'reverseGeocode': 'Geocodifica inversa'
    },
    'apiKey': 'Chiave API',
    'customApiKey': 'Custom Chiave API',
    'apiBaseUrl': 'URL base dell\'API',
    'invalidSettingsValue': 'Inserimento non valido. Ricontrolla i campi o ripristina i valori di default',
    'restoreDefaults': 'Ripristina dati predefiniti',
    'advanced': 'Avanzate',
    'mapSettingsSaved': 'Impostazioni mappa salvate',
    'alwaysFitBounds': 'Zoom su tutta la grandezza dell\'itinerario',
    'routeExtraInfo': 'Informazioni extra',
    'mapViewOptions': 'Opzioni visualizzazione mappa',
    'advancedSettingsWarning': 'Non cambiare le impostazioni sotto se non sai cosa stai facendo!',
    'customOverlayerTileProviderUrl': 'URL del provider strato personalizzato',
    'customTileProviderUrl': 'URL del provider delle mattonelle (tiles) personalizzate',
    'defaultTilesProvider': 'Provider predefinito delle mattonelle (tiles)',
    'customTileProviderUrlHint': 'https://dominio.tld/path/{z}/{x}/{y}.ext?chiaveOpzionale=valore',
    'prioritizeSearchingForNearbyPlaces': 'Ricerca dà priorità ai luoghi vicini',
    'defaultProfile': 'Profilo standard',
    'compressDataUrlSegment': 'Comprimi segmento URL dopo /data/',
    'autoFitHighlightedBounds': 'Autozoom su segmenti selezionati',
    'reloadToApplyLanguageChangeTitle': 'L\'applicazione deve essere ricaricata',
    'reloadToApplyLanguageChangeText': 'Al fine di eseguire il cambio della lingua è necessario ricaricare l\'applicazione. Ricarica adesso?',
    'resetShownOnceTooltips': 'Mostra di nuovo indicazioni',
    'convertStopAfterRouteEndingToDestination': 'Converti in destinazione la fermata dopo la fine del percorso',
    'skipAllSegments': 'percorso rettilineo per tutti i segmenti',
    'useStopOptimization': 'Ottimizza il percorso quando viene creata una sosta tramite trascinamento / salto'
  }
}
